import axiosInstance from "../../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

const multipartHeaders = {
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
};

const buildSubCategoryFormData = (formData) => {
  const data = new FormData();
  if (formData.id) data.append("Id", formData.id);
  data.append("CategoryId", formData.CategoryId || "");
  data.append("SubCategoryName", formData.SubCategoryName || "");
  data.append("SubCategorySlug", formData.SubCategorySlug || "");
  data.append("ShortDesc", formData.ShortDesc || "");
  data.append("FullDesc", formData.FullDesc || "");
  data.append("MetaTitle", formData.MetaTitle || "");
  data.append("MetaDesc", formData.MetaDesc || "");
  data.append("MetaKeywords", formData.MetaKeywords || "");
  if (formData.SubCategoryImage instanceof File) {
    data.append("SubCategoryImage", formData.SubCategoryImage);
  }
  return data;
};

export const addSubCategory = async (formData) => {
  const response = await axiosInstance.post(
    "product-subcategory/add",
    buildSubCategoryFormData(formData),
    { headers: multipartHeaders }
  );
  return response.data;
};

export const updateSubCategory = async (formData) => {
  const response = await axiosInstance.put(
    "product-subcategory/update",
    buildSubCategoryFormData(formData),
    { headers: multipartHeaders }
  );
  return response.data;
};

export const deleteSubCategory = async (id) => {
  return await axiosInstance.delete(`product-subcategory/delete/${id}`, {
    headers,
  });
};

export const fetchSubCategoryData = async (id) => {
  const response = await axiosInstance.get(
    `product-subcategory/GetProductSubCategory/${id}`,
    { headers }
  );
  return response.data.result;
};

export const getAllSubCategories = async () => {
  return await axiosInstance.get(
    "product-subcategory/GetAllProductSubCategories",
    { headers }
  );
};

export const getSubCategoriesByCategory = async (categoryId) => {
  const response = await axiosInstance.get(
    `product-subcategory/GetByCategory/${categoryId}`,
    { headers }
  );
  return response.data.result;
};

export const fetchSubCategoryBySlug = async (slug) => {
  const response = await axiosInstance.get(
    `product-subcategory/GetProductSubCategoryBySlug/${slug}`,
    { headers }
  );
  return response.data.result;
};